// Deterministic avatar color from a string (name/email).
const PALETTE = [
  "#FF4C4C",
  "#FFDE59",
  "#A8FF76",
  "#7DD3FC",
  "#F472B6",
  "#FB923C",
  "#C084FC",
  "#34D399",
];

export function colorForName(name) {
  if (!name) return PALETTE[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) | 0;
  const idx = Math.abs(hash) % PALETTE.length;
  return PALETTE[idx];
}

export function initialFromName(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return (parts[0][0] || "?").toUpperCase();
}
